"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serializeMatch = (match) => ["params", "isExact", "path", "url"].reduce((obj, key) => {
    if (key === "params") {
        return { ...obj, [key]: JSON.stringify(match[key]) };
    }
    return { ...obj, [key]: match[key] };
}, {});
exports.default = serializeMatch;
